import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { cloneDeep, get, isEmpty } from 'lodash';
import { Container } from 'containers/LawyerLegalProceedingsPage/judgementAdd/styled-components';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { Listings } from 'containers/AppContainer/typings';
import { CivilParty as ICivilParty } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import { DATE_FORMAT } from 'constants/global';
import { validationCourtFileNumber } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';
import {
  IJudgementAdd,
  IUploadedDocument,
} from 'containers/LawyerLegalProceedingsPage/typings';
import {
  CorporealDocument,
  JudgementADDDocumentType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Idetails } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import { EMPTY_DETAIL, PROCEDURE_STATUSES } from 'containers/data-structure';
import FormsADD from 'containers/LawyerLegalProceedingsPage/judgementAdd/FormsADD';
import RecapADD from 'containers/common/LegalProceedings/JudgementAdd/Recap';
import { detailsValidator } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/form-validation';
import { validateFormFields } from 'containers/services/validateForm';
import { arrayTranslate } from 'containers/services/translate';
import { displayErrorText } from 'containers/services/validateForm';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import {
  EMPTY_SUPPORT_DOC,
  SUPPORT_DOC_ID,
  SUPPORT_DOC_JUDGEMENT_ADD_ID,
} from 'containers/LawyerRecapPage/constants';
import {
  IndexState,
  IOpenState,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/typings';
import {
  CURRENT_INDEX_STATE,
  DRAWERS,
  DRAWERS_STATE,
} from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import EditJudgementAddOnRejection from 'containers/LawyerLegalProceedingsPage/judgementAdd/EditJudgementAddOnRejection';
import {
  getVehicles,
  getVictims,
  toBeEdited,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import withLoading from 'containers/AppContainer/withLoading';
import { addDaysToDate } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { STATUS_PENDING } from 'containers/LawyerFeeNote/constants';
import { VictimType } from 'typings/globalTypes';

export interface JudgementAddProps {
  intl: IntlShape;
  victims: VictimType[];
  listings: Listings;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  vehicules: Vehicule[];
  resetUploadedDocument: Function;
  requestCreateJudgementAdd: Function;
  claimId: number;
  claimNumber: string;
  judgementAdd: IJudgementAdd;
  requestGetJudgementAdd: Function;
  policyInfo: { sagis: {} };
  judiciaryProcessId: number;
  isCivilProceeding: boolean;
  stakeholders: any;
  assignedLawyer: any;
  lossDate: string;
  requestCreateMultipleJudgementAdd: Function;
  docId?: string;
  setDocumentId: Function;
  documentId: string;
  requestAddSupportDocument?: Function;
  requestCivilPartySupportDocument?: Function;
  requestUpdateJudgementAdd: Function;
  requestUpdateJudgementAddDocument?: Function;
  currentJudiciaryProcess?: any;
  isAssignedLawyer: boolean;
  setDialogOpenFirmReference?: Function;
  loaders: any;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  feeNotes: any;
  requestCreateIncomeCertificate: Function;
  requestUpdateIncomeCertificate: Function;
  riskKey: string;
  requestMakeDecisionSupportDocument?: Function;
  dahirAmount: [];
  requestGetDocByDocumentumId: Function;
}

export const JudgementAdd: React.FC<JudgementAddProps> = (
  props,
): JSX.Element => {
  const [details, setDetails] = useState<Idetails>(
    cloneDeep(EMPTY_DETAIL) as any,
  );
  const claim = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap'], []),
  );
  const [judgementAddDocuments, setJudgementAddDocuments] = useState<
    JudgementADDDocumentType[]
  >([]);
  const [civilPartyDocuments, setCivilPartyDocuments] = useState<ICivilParty[]>(
    [],
  );
  const [
    areProcedureInformationValidated,
    setAreProcedureInformationValidated,
  ] = useState<boolean>(false);
  const [isCivilPartyPresent, setIsCivilPartyPresent] = useState<boolean>(
    false,
  );
  const [
    processInformationValidation,
    setProcessInformationValidation,
  ] = useState<any>({});
  const [
    validateJudgementAddProcedure,
    setValidateJudgementAddProcedure,
  ] = useState<any>();
  const [messageError, setMessageError] = useState<any>({});

  useEffect(() => {
    const procedureInformationValidation = detailsValidator(details);
    setProcessInformationValidation(procedureInformationValidation);
    const translateArrayErrorMessages = arrayTranslate(
      props.intl.formatMessage,
    );
    const { message } = displayErrorText(
      procedureInformationValidation,
      translateArrayErrorMessages(procedureInformationValidation, true),
    );
    setMessageError(message);
    setAreProcedureInformationValidated(
      !!validateFormFields(procedureInformationValidation) &&
        !(
          new Date(addDaysToDate(props.lossDate || '', 1) || '') >
          new Date(get(details, 'hearingDate') || '')
        ) &&
        !!validationCourtFileNumber(details.courtFile) &&
        moment(get(details, 'hearingDate')).format(DATE_FORMAT) !=
          'Invalid date',
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details, props.victims]);
  useEffect(() => {
    setIsCivilPartyPresent(!isEmpty(civilPartyDocuments));
    setValidateJudgementAddProcedure(
      props.isCivilProceeding
        ? areProcedureInformationValidated
        : areProcedureInformationValidated && !isEmpty(civilPartyDocuments),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    civilPartyDocuments,
    details,
    areProcedureInformationValidated,
    props.victims,
  ]);

  const shouldDisplayRecap =
    !isEmpty(props.judgementAdd) || !props.isAssignedLawyer;

  const [supportDocument, setSupportDocument] = useState({
    ...EMPTY_SUPPORT_DOC,
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState<IOpenState>({
    ...DRAWERS_STATE,
  });
  const [currentIndex, setCurrentIndex] = useState<IndexState>(
    CURRENT_INDEX_STATE,
  );
  const [judgementAdd, setJudgementAdd] = useState<IJudgementAdd | {}>({});

  const setDocument = (document: CorporealDocument) => {
    if (SUPPORT_DOC_ID === props.documentId) {
      setSupportDocument(document);
      props.requestCivilPartySupportDocument &&
        props.requestCivilPartySupportDocument({
          ...document,
          isLawyer: true,
          judgementAddId: get(props.judgementAdd, ['judgementAdd', 'id']),
          claimId: props.claimId,
          claimNumber: props.claimNumber,
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
          status: STATUS_PENDING,
        });
      props.resetUploadedDocument();
    }
  };

  const [supportDocumentAdd, setSupportDocumentAdd] = useState({
    ...EMPTY_SUPPORT_DOC,
  });

  const setDocumentAdd = (document: CorporealDocument) => {
    if (SUPPORT_DOC_JUDGEMENT_ADD_ID === props.documentId) {
      setSupportDocumentAdd(document);
      props.requestAddSupportDocument &&
        props.requestAddSupportDocument({
          ...document,
          isLawyer: true,
          status: STATUS_PENDING,
          judgementAddId: get(props.judgementAdd, ['judgementAdd', 'id']),
          claimId: props.claimId,
          claimNumber: props.claimNumber,
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
        });
      props.resetUploadedDocument();
    }
  };

  const readOnly = toBeEdited(get(props, 'judgementAdd.status', ''));
  const handleIsDrawerOpen = (drawer: string) => (index?: number) => (
    event?: React.ChangeEvent<{}>,
  ) => {
    event && event.stopPropagation();

    const previousState = isDrawerOpen[drawer];

    setIsDrawerOpen({
      ...isDrawerOpen,
      [drawer]: !previousState,
    });
    setCurrentIndex({ ...currentIndex, [drawer]: index as number });
  };
  return (
    <Container id="add-bloc">
      {shouldDisplayRecap ? (
        <RecapADD
          listings={props.listings}
          judgementAdd={judgementAdd}
          judgementAddStore={props.judgementAdd}
          isCivilProceeding={props.isCivilProceeding}
          stakeholders={props.stakeholders}
          assignedLawyer={props.assignedLawyer}
          victims={getVictims(
            props.isCivilProceeding,
            props.currentJudiciaryProcess,
            props.judgementAdd,
            props.victims,
            claim,
          )}
          vehicules={getVehicles(
            props.isCivilProceeding,
            props.currentJudiciaryProcess,
            props.judgementAdd,
            props.vehicules,
          )}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocument={props.resetUploadedDocument}
          requestCreateMultipleJudgementAdd={
            props.requestCreateMultipleJudgementAdd
          }
          handleOnEditCivilPartyClick={handleIsDrawerOpen(DRAWERS.CIVIL_PARTY)}
          handleOnEditJudgementAddClick={handleIsDrawerOpen(
            DRAWERS.JUDGEMENT_ADD,
          )}
          handleOnEditProcedureInfoClick={handleIsDrawerOpen(
            DRAWERS.PROCEDURE_INFORMATION,
          )}
          claimNumber={props.claimNumber}
          judiciaryProcessId={props.judiciaryProcessId}
          isManager={
            userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) ||
            userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER)
          }
          policyInfo={props.policyInfo}
          readOnly={!readOnly}
          document={supportDocument}
          setDocument={setDocument}
          documentAdd={supportDocumentAdd}
          setDocumentAdd={setDocumentAdd}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          setJudgementAdd={setJudgementAdd}
          requestUpdateJudgementAddDocument={
            props.requestUpdateJudgementAddDocument
          }
          currentJudiciaryProcess={props.currentJudiciaryProcess}
          isCreator={
            get(props.judgementAdd, 'lawyerCode') ===
              currentIntervenantStorage.get()?.sagis_code ||
            (userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCOURTMONITORINGMANAGER,
            ) &&
              get(props.judgementAdd, 'status', '') ===
                PROCEDURE_STATUSES.TO_EDIT)
          }
          isAssignedLawyer={props.isAssignedLawyer}
          setDialogOpenFirmReference={props.setDialogOpenFirmReference}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
          feeNotes={props.feeNotes}
          setOpenFeeNoteDialog={() => {}}
          requestCreateIncomeCertificate={props.requestCreateIncomeCertificate}
          requestUpdateIncomeCertificate={props.requestUpdateIncomeCertificate}
          isConsultation={!props.isAssignedLawyer}
          riskKey={props.riskKey}
          requestMakeDecisionSupportDocument={
            props.requestMakeDecisionSupportDocument
          }
          imagineDocuments={[]}
          dahirAmount={props.dahirAmount}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      ) : (
        ((!shouldDisplayRecap &&
          !userPrivileges.userHasPrivilege(
            PRIVILEGES.ISCOURTMONITORINGMANAGER,
          )) ||
          (!shouldDisplayRecap &&
            !props.isCivilProceeding &&
            userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCOURTMONITORINGMANAGER,
            ))) && (
          <FormsADD
            judiciaryProcessId={props.judiciaryProcessId}
            victims={getVictims(
              props.isCivilProceeding,
              props.currentJudiciaryProcess,
              props.judgementAdd,
              props.victims,
              claim,
            )}
            vehicules={getVehicles(
              props.isCivilProceeding,
              props.currentJudiciaryProcess,
              props.judgementAdd,
              props.vehicules,
            )}
            listings={props.listings}
            isCivilProceeding={props.isCivilProceeding}
            claimId={props.claimId}
            claimNumber={props.claimNumber}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            resetUploadedDocument={props.resetUploadedDocument}
            requestCreateJudgementAdd={props.requestCreateJudgementAdd}
            details={details}
            judgementAddDocuments={judgementAddDocuments}
            civilPartyDocuments={civilPartyDocuments}
            setDetails={setDetails}
            setJudgementAddDocuments={setJudgementAddDocuments}
            setCivilPartyDocuments={setCivilPartyDocuments}
            canValidateJudgementAddProcedure={validateJudgementAddProcedure}
            canStartCivilParty={areProcedureInformationValidated}
            canStartJudgementAdd={isCivilPartyPresent}
            policyInfo={props.policyInfo}
            processInformationValidation={processInformationValidation}
            messageError={messageError}
            lossDate={props.lossDate}
            currentJudiciaryProcess={props.currentJudiciaryProcess}
            setDialogOpenFirmReference={props.setDialogOpenFirmReference}
            isManager={
              userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) ||
              userPrivileges.userHasPrivilege(
                PRIVILEGES.ISCOURTMONITORINGMANAGER,
              )
            }
            sagisVictimInfo={props.sagisVictimInfo}
            sagisOpposingParties={props.sagisOpposingParties}
            setDocumentId={props.setDocumentId ? props.setDocumentId : () => {}}
            documentId={props.documentId}
            feeNotes={props.feeNotes}
            requestCreateIncomeCertificate={
              props.requestCreateIncomeCertificate
            }
            requestUpdateIncomeCertificate={
              props.requestUpdateIncomeCertificate
            }
            requestMakeDecisionIncomeCertificate={() => {}}
            isConsultation={!props.isAssignedLawyer}
            riskKey={props.riskKey}
            imagineDocuments={[]}
            dahirAmount={props.dahirAmount}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        )
      )}
      <EditJudgementAddOnRejection
        listings={props.listings}
        vehicules={props.vehicules}
        judgementAddStore={props.judgementAdd}
        setJudgementAdd={setJudgementAdd}
        judgementAdd={judgementAdd}
        isDrawerOpen={isDrawerOpen}
        handleIsDrawerOpen={handleIsDrawerOpen}
        isCivilProceeding={props.isCivilProceeding}
        currentIndex={currentIndex}
        victims={props.victims}
        lossDate={props.lossDate}
        claimNumber={props.claimNumber}
        requestUpdateJudgementAdd={props.requestUpdateJudgementAdd}
        uploadDocument={props.uploadDocument}
        uploadedDocument={props.uploadedDocument}
        resetUploadedDocument={props.resetUploadedDocument}
        setDocumentId={props.setDocumentId ? props.setDocumentId : () => {}}
        documentId={props.documentId}
        isAssignedLawyer={
          get(props.judgementAdd, 'lawyerCode') ===
          currentIntervenantStorage.get()?.sagis_code
        }
        sagisVictimInfo={props.sagisVictimInfo}
        sagisOpposingParties={props.sagisOpposingParties}
        currentJudiciaryProcess={props.currentJudiciaryProcess}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        feeNotes={props.feeNotes}
      />
    </Container>
  );
};

export default withLoading(injectIntl(JudgementAdd), [LOADERS.JUDGEMENT_ADD]);
